import wxGuide from './wxGuide.vue';

let guideVM = null;
wxGuide.install = function (Vue) {
    Vue.component(wxGuide.name, wxGuide);

    Vue.prototype.$wxGuide = function () {
        if (guideVM) {
            guideVM.showGuide();
            return;
        }
        let GuideTpl = Vue.extend(wxGuide);
        guideVM = new GuideTpl();
        guideVM.showGuide();
        let tpl = guideVM.$mount().$el;
        document.body.appendChild(tpl);
    };
};

export default wxGuide;